export const WeltboardActions = ({updateData}) => {
    return {
        WELTBOARD_DIALOG_OPEN: ({objekt}) => {
            updateData(objekt, "/weltboard/selectedObjekt")
            updateData(true, "/weltboard/dialog")
        },
        WELTBOARD_CLOSE_DIALOG: () => {
            updateData(false, "/weltboard/dialog")
        },
    }
}
